import { ListItemText, MenuItem } from '@material-ui/core';
import Menu from "@material-ui/core/Menu";
import { withStyles } from "@material-ui/core/styles";
import MoreVert from "@material-ui/icons/MoreVert";
import { notification } from "antd";
import Button from "components/CustomButtons/Button.js";
import React from 'react';
import { useTranslation } from "react-i18next";
import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { deleteHTMLTemplate,fetchHTMLTemplates } from 'reduxToolkit/features/HTMLTemplate/HTMLTemplateSlice';
import SuperGeneralDeleteModal from 'views/Components/SuperGeneralDeleteModal';
const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
));

export default function MailTempDropDownButton(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  console.log(props)
  const [editDisabled, setEditDisabled] = React.useState(false)
  //console.log('editDisabled', editDisabled)
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [handledError, setHandledError] = React.useState("");

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };
  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const handleOpenDeleteModal = () => {
    setOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setOpen(false);
  };
  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };

  const handleDeleteMailTemplate = async () => {
    try {
      const result = await dispatch(deleteHTMLTemplate(props.id))
      console.log("originalPromiseResult", result);
      openNotificationWithIcon("success", `Deleted`);
      dispatch(fetchHTMLTemplates())
      } catch (error) {
        console.log("rejectedValueOrSerializedError", error);
      
    }
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div>
      <Button
        // aria-describedby={id}
        aria-controls="customized-menu"
        variant="contained"
        color="primary"
        onClick={handleClick}
        justIcon
        round
        aria-haspopup="true"
      >
        <MoreVert />
      </Button>

      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <Link to={`/citrine/mailTemplates/${props?.id}`}>
          <MenuItem disabled={editDisabled}>
            <ListItemText style={{ color: "black" }} primary="Edit" />
          </MenuItem>
        </Link>

        <MenuItem
          onClick={() => {
            handleOpenDeleteModal();
            handleClose();
          }}
        >
          <ListItemText primary="Delete" />
        </MenuItem>
        <SuperGeneralDeleteModal
          delete_Element={handleDeleteMailTemplate}
          Element_ID={props.id}
          open={open}
          handleClose={handleCloseDeleteModal}
        />
      </StyledMenu>
      {/* <ErrorsModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        //handledError={handledError}
      /> */}
    </div>
  )
}
